'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _Collapse = require('./Collapse');

var _Collapse2 = _interopRequireDefault(_Collapse);

exports['default'] = _Collapse2['default'];
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-collapse/lib/index.js
 ** module id = 547
 ** module chunks = 0
 **/